// src/components/pages/Home/SpiritualHope/SpiritualHope.tsx
import React from 'react';
import verseBg from '/images/verse-bg.png';
import { SpiritualContainer, SpiritualContent } from './SpiritualHope.styles';

const SpiritualHope: React.FC = () => {
  return (
    <SpiritualContainer $backgroundImage={verseBg}>
      <SpiritualContent>
        <h2>Spiritual Hope</h2>
        <p>
          "Blessed are those who mourn, for they will be comforted." - Matthew 5:4
        </p>
      </SpiritualContent>
    </SpiritualContainer>
  );
};

export default SpiritualHope;
